module.exports = __webpack_public_path__ + "static/media/slide-full-image.94e5b1c9.webp";